import { render, staticRenderFns } from "./InputSenha.vue?vue&type=template&id=478d64c5&scoped=true&"
import script from "./InputSenha.vue?vue&type=script&lang=js&"
export * from "./InputSenha.vue?vue&type=script&lang=js&"
import style0 from "./InputSenha.vue?vue&type=style&index=0&id=478d64c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478d64c5",
  null
  
)

export default component.exports